import { ExpressionRule } from "../../ExpressionRule";
import { IDataDefinition } from "../../../Common/Data/Definitions/IDataDefinition";
import { BooleanDataDefinition } from "../../../Common/Data/Definitions/BooleanDataDefinition";

export abstract class BaseLogicExpression extends ExpressionRule {
    protected _expressionValueType: IDataDefinition = new BooleanDataDefinition();

    get expressionValueType(): IDataDefinition {
        return this._expressionValueType;
    }

    set expressionValueType(expressionValueType: IDataDefinition) {
        this._expressionValueType = expressionValueType;
    }
}
